 /*
 Author: Vaishnavi
 Date: 26/11/2019
 Issue Description: Spacing fixes as per design guidelines.
*/

/*
 Author: Vinod
 Date: 03/03/2020, 13/03/2020
 Issue Description:  Fixed base days value is changing in LE Level.
 search_string: PL_2870
*/
/*
 Author: Vinod
 Date: 03/03/2020
 Issue Description:  Instead of "Value" It shows the criteria chosen in the label.
 search_string: PL_2869
*/

/*
 Author: Vinod
 Date: 16/03/2020
 Issue Description:  The Default paygroup settings should be there, but by default it shows custom.
 search_string: PL_1848
*/

/*
 Author: Vinod
 Date: 19/03/2020
 Issue Description: Able to get the values without selecting the criteria.
 search_string: PL_2960
*/

/*
 Author: Vinod
 Date: 19/03/2020
 Issue Description: Paygroup should also create after just selecting custom in drop down.
 search_string: PL_3027
*/


/*
 Author: Vinod
 Date: 08/04/2020
 Issue Description: Even after deselecting weekly offs, they are going in request.
 search_string: PL_3046
*/

/*
 Author: Vinod
 Date: 15/04/2020
 Issue Description: Unable to create or edit pay groups.
 search_string: PL_3062
*/

<template>
  <div class="business">
    <div class="top-bar" v-if="!showPayrollCycle && !showPayComputation && !showPayslipPreferences">
      <span @click="goBackToPaygroup">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">{{heading}}</span>
    </div>
    <toast-message
      v-if="!showPayrollCycle && !showPayComputation && !showPayslipPreferences"
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div
      class="content-new"
      v-if="!showPayrollCycle && !showPayComputation && !showPayslipPreferences"
    >
      <section class="custom-grid">
        <txt
          label="Code"
          class
          type="text"
          placeholder="Enter code"
          name="Code"
          v-model="paygroupFormData.code"
        />
        <txt
          label="Name *"
          class
          type="text"
          name="paygroupName"
          v-model="paygroupFormData.name"
          data-vv-as="name"
          v-validate="{required: true, max: nameMaxlength}"
          :classname="errors.has('paygroupName')"
          :errormsg="errors.first('paygroupName')"
        />
      </section>
      <div class="custom-grid margin-t-25px">
        <txt
          name="paygroupDescription"
          label="Description"
          maxlength="250"
          type="textarea"
          rows="5"
          v-model="paygroupFormData.description"
          data-vv-as="description"
          v-validate="{required: false, max: descriptionMaxlength}"
          :classname="errors.has('paygroupDescription')"
          :errormsg="errors.first('paygroupDescription')"
        ></txt>
        <div>
        <div class="input-label margintop-32">Is Apply LOP?</div>
      <div class="row margintop-16">
        <tl-radio
        name="applylop"
        class="col-2"
        label="Yes"
        id="applyLop1"
        :value="true"
        v-model="paygroupFormData.applylop"
        @change="onChangeApplyLOP(paygroupFormData.applylop)"
        />
        <tl-radio
        name="applylop"
        class="col-1"
        label="No"
        id="applyLop2"
        v-model="paygroupFormData.applylop"
        :value="false"
        @change="onChangeApplyLOP(paygroupFormData.applylop)"
        />
      </div>
      </div>
      </div>
      <section class="custom-grid margin-tb-m">
        <tl-select
          name="Criteria"
          class="marginright-32"
          id="Criteria"
          label="Criteria"
          labelText="name"
          :options="criteriaArray"
          v-model="paygroupFormData.criteriaObj"
          @change="(val) => changeCriteria(val)"
        />
        <!-- PL_2869, PL_2870 -->
        <tl-select
          v-if="subCriteriaLabel"
          name="SubCriteria"
          id="SubCriteria"
          :label="subCriteriaLabel"
          labelText="name"
          :options="valueArray"
          :multiple="true"
          v-model="paygroupFormData.valueObj"
          @change="(val) => paygroupFormData.valueObj=val"
        />
      </section>
      <!-- PL_2870 -->
      <data-table
        :columns="columns"
        :tableData="paygroupData"
        class="custom-data-table-class"
        :checkbox="false"
        :withForm="false"
        :showinrow="false"
        :showedit="true"
      >
        <template v-slot:rowcontent="slotprops">
          <p
            v-if="slotprops.value.column.key=='name'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <tl-select
            v-if="slotprops.value.column.key=='copySettings'"
            class="custom-width-slotprop"
            :name="'copysetting'+slotprops.value.index"
            labelText="name"
            :id="'copysetting'+slotprops.value.index"
            v-model="paygroupData[slotprops.value.index].paygroupObj"
            :options="payGroupListArray"
            :disable="paygroupFormData.default"
            @change="(val)=>{paygroupData[slotprops.value.index].paygroupObj = val;paygroupSelectionChange(val,slotprops.value.index)}"
            data-vv-as="copy settings from"
            v-validate="{required: true}"
            :classname="errors.has('copysetting'+slotprops.value.index)"
            :errormsg="errors.first('copysetting'+slotprops.value.index)"
          />
          <img
            class="alignClass"
            :class="{'disabled': !(paygroupData[slotprops.value.index].paygroupObj && paygroupData[slotprops.value.index].paygroupObj['name'] == 'Custom')}"
            src="@/assets/edit.svg"
            v-if="slotprops.value.column.key=='customize'"
            @click="editPaygroupData(paygroupData[slotprops.value.index])"
          />
        </template>
      </data-table>
    <pop-up-message
      v-if="showSuccessMsg && !showPayrollCycle && !showPayComputation && !showPayslipPreferences"
      :message="`Paygroup has been successfully added.`"
      btnText="Back To Paygroups"
      @back="backfrompopup()"
    />
    <bottom-action-container
      class="placeEnd"
      v-if="!showPayrollCycle && !showPayComputation && !showPayslipPreferences"
    >
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="goBackToPaygroup"></btn>
          <btn :text="btnText" type="primary" @click="savePaygroup"></btn>
        </btn-grp>
      </template>
    </bottom-action-container>
      </div>
    <payroll-cycle
      @payrollcycle="hidePayrollCycle()"
      @updatePayrollCycle="getThecustomPayCycleData"
      :payrollCycleData="payrollCycleData"
      v-if="showPayrollCycle && !showPayComputation && !showPayslipPreferences"
    />
    <pay-computation
      @paycomputation="hidepaycomputation()"
      @updatePaycomputation="getComputationData"
      :payComputationData="payComputationData"
      v-if="showPayComputation && !showPayslipPreferences"
    />
    <!-- PL_2480 -->
    <payslip-preferences
      :isCustom="isCustom"
      @payslippreferences="(val) => hidepayslippreferences(val)"
      v-if="showPayslipPreferences"
    />

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import PayrollCycle from "./editPayrollCycle.vue";
import PayComputation from "./editPayComputation.vue";
import PayslipPreferences from "./editPayslipPreferences.vue";
import { criteriaObj } from "../../../../../../apis/constants.js";
import * as config from "@/apis/config.js";

export default {
  components: {
    PayrollCycle,
    PayComputation,
    PayslipPreferences
  },
  computed: {
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add New Paygroup";
      }
    },
    ...mapState({
      business_units: state => state.onboard.business_units.data,
      salary_bands: state => state.onboard.salary_bands.data,
      locations: state => state.onboard.locations.data,
      salary_grades: state => state.onboard.salary_grades.data,
      cost_centres: state => state.onboard.cost_centres.data,
      designations: state => state.onboard.designations.entityWiseData
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      record: "onboard/paygroup/record",
      editMode: "onboard/paygroup/editMode"
    })
  },

  data() {
    return {
      nameMaxlength: null,
      descriptionMaxlength: null,
      pgPayCycle_id: null,
      pgPayComputation_id: null,
      pgPayslip_id: null,
      isCustom: false,
      criteriaArray: criteriaObj.paygroupCriteria,
      valueArray: [],
      subCriteriaLabel: "", // PL_2869
      heading: "",
      showPayrollCycle: false,
      showPayComputation: false,
      showPayslipPreferences: false,
      paygroupObj: {},
      payGroupListArray: [],
      applylop: null,
      columns: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Copy Settings From",
          key: "copySettings"
        },
        {
          label: "Customize",
          key: "customize"
        }
      ],
      paygroupData: [],
      payrollCycleData: {},
      payComputationData: {},
      paySlipMapData: {},
      paygroupFormData: {
        code: "",
        name: "",
        criteriaObj: {
          name: ""
        },
        valueObj: [],
        default: false,
        description: ""
      },
      showSuccessMsg: false,
      errmsg: "",
      toast: false
    };
  },
  mounted() {
    this.setGlobalValidations();
    this.refresh();
    this.fetchPaygroups();
  },

  activated() {
    this.setGlobalValidations();
    this.refresh();
    this.fetchPaygroups();
    this.getDesignations();
    this.getGrades();
    this.getBands();
    this.getLocationList();
    this.showPayrollCycle = false;
    this.showPayComputation = false;
    this.showPayslipPreferences = false;
    if (!this.editMode) {
      this.heading = "Paygroups";
    }
  },

  methods: {
    ...mapActions("onboard/", {
      fetch_paygroups_list: "paygroup/fetchAll",
      act_create: "paygroup/create",
      act_update: "paygroup/update",
      fetch_grades: "salary_grades/fetchAll",
      fetch_bands: "salary_bands/fetchAll",
      fetch_locations: "locations/fetchAll",
      fetch_businessunits: "business_units/fetchAll",
      fetch_cost_center: "cost_centres/fetchAll",
      fetch_designation: "designations/fetchAll"
    }),

    onChangeApplyLOP(applylop) {
      if(applylop == 'true') {
        this.paygroupFormData.applylop = true;
      } else {
        this.paygroupFormData.applylop = false;
      }
    },

    /* function to set validations */
    setGlobalValidations() {
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.descriptionMaxlength = config.MaxLengthSettings.descriptionLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set paygroup data while editing */
    getRecord() {
      try {
        if (this.payGroupListArray.length) {
          this.paygroupFormData.code = this.record.code;
          this.paygroupFormData.name = this.record.name;
          this.paygroupFormData.description = this.record.description;
          this.paygroupFormData.default = this.record.default;
          if (this.record.attribute) {
            this.paygroupFormData.criteriaObj = this.record.attribute.criteria;
            this.setSelectedSubCriteria(this.record.attribute.subCriteria);
          }
          this.heading = "Paygroup - " + this.paygroupFormData.name;
          this.setSelectedPayGroupsValues(this.record);
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to set the 'copy setting from' dropdown values while editing */
    setSelectedPayGroupsValues(record) {
      try {
        /*** Payroll Cycle ***/
        if (record.PaygroupPayrollCycle) {
          let obj = record.PaygroupPayrollCycle[0];  // PL_3062
          this.pgPayCycle_id =
            obj.PayrollCycle && obj.PayrollCycle.selected_paygroup_id
              ? obj.PayrollCycle.selected_paygroup_id
              : record.default // PL_1848
              ? record.id
              : null;
          this.payrollCycleData = obj.PayrollCycle; // PL_3046
          if (this.pgPayCycle_id == null) {
            this.paygroupObj.PaygroupPayrollCycle = obj; // PL_3046
          }
          this.paygroupData[0].paygroupObj = this.pgPayCycle_id
            ? this.payGroupListArray.find(data => data.id == this.pgPayCycle_id)
            : this.paygroupObj;
        }
        /*** Pay Computation ***/
        if (record.PaygroupPayComputation) {
          let obj = record.PaygroupPayComputation[0];  // PL_3062
          this.pgPayComputation_id =
            obj.PayComputation && obj.PayComputation.selected_paygroup_id
              ? obj.PayComputation.selected_paygroup_id
              : record.default // PL_1848
              ? record.id
              : null;
          this.payComputationData = obj.PayComputation;  // PL_3046
          if (this.pgPayComputation_id == null) {
            this.paygroupObj.PaygroupPayComputation = obj;  // PL_3046
          }
          this.paygroupData[1].paygroupObj = this.pgPayComputation_id
            ? this.payGroupListArray.find(
                data => data.id == this.pgPayComputation_id
              )
            : this.paygroupObj;
        }
        /*** Payslip Preferences ***/
        if (record.PayslipMapping) {
          let obj = record.PayslipMapping[0];    // PL_3062
          this.pgPayslip_id =
            obj.preferences && obj.preferences.selected_paygroup_id
              ? obj.preferences.selected_paygroup_id
              : record.default // PL_1848
              ? record.id
              : null;

          this.paySlipMapData = obj.preferences;   // PL_3046
          if (this.pgPayslip_id == null) {
            this.paygroupObj.PayslipMapping = obj;  // PL_3046
          }
          this.paygroupData[2].paygroupObj = this.pgPayslip_id
            ? this.payGroupListArray.find(data => data.id == this.pgPayslip_id)
            : this.paygroupObj;
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },
    //  PL_2870

    /* function to get pay group table list to add/edit paygroup*/
    setPaygroupTableData() {
      return [
        {
          name: "Payroll Cycle",
          copySettings: "true",
          customize: true,
          paygroupObj: null
        },
        {
          name: "Pay Computation",
          copySettings: "true",
          customize: true,
          paygroupObj: null
        },
        {
          name: "Payslip Preferences",
          copySettings: "true",
          customize: true,
          paygroupObj: null
        }
      ];
    },

    /* function to set paygrup object for custom */
    setPayGroupObjectData() {
      return {
        PaygroupPayComputation: null, // PL_3027
        PaygroupPayrollCycle: null, // PL_3027
        PayslipMapping: null, // PL_3027
        attribute: null,
        code: "Custom",
        createdBy: null,
        created_at: "",
        customAttr: null,
        default: false,
        deleted_at: null,
        description: "",
        le_id: "",
        name: "Custom",
        priority: null,
        rule: null,
        updatedBy: null,
        updated_at: ""
      };
    },

    /* server call to get paygroups for current LE */
    async fetchPaygroups() {
      try {
        this.payGroupListArray = [];
        this.paygroupData = this.setPaygroupTableData(); // PL_2870
        this.paygroupObj = this.setPayGroupObjectData(); //PL_2870
        let res = await this.fetch_paygroups_list(this.le_id);
        if (res.data.status) {
          this.payGroupListArray = res.data.payload.data;
          this.payGroupListArray.push(this.paygroupObj); // PL_3046
          if (this.editMode) {
            // PL_3046
            let index = this.payGroupListArray.findIndex(
              item => item.id == this.record.id
            );
            if (index > -1 && !this.record.default) {
              this.payGroupListArray.splice(index, 1);
            }
            this.getRecord();
          }
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to set selected subcriteria while editing paygroup */
    setSelectedSubCriteria(obj) {
      try {
        this.changeCriteria(this.paygroupFormData.criteriaObj);
        setTimeout(() => {
          if (this.valueArray.length) {
            this.paygroupFormData.valueObj = this.valueArray.filter(item => {
              if (obj.some(element => element == item.id)) {
                return item;
              }
            });
          }
        }, 500);
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to get subcriteria list based on selected criteria */
    changeCriteria(event) {
      try {
        if (event) {
          this.valueArray = [];
          this.paygroupFormData.criteriaObj = event;
          this.paygroupFormData.valueObj = [];
          this.subCriteriaLabel = event; // PL_2869
          switch (this.paygroupFormData.criteriaObj) {
            case "Location":
              this.valueArray = this.locations
                ? this.locations[this.le_id]
                : [];
              break;
            case "Salary Band":
              this.valueArray = this.salary_bands
                ? this.salary_bands[this.le_id]
                : [];
              break;
            case "Grade":
              this.valueArray = this.salary_grades
                ? this.salary_grades[this.le_id]
                : [];
              break;
            case "BUs":
              this.valueArray = this.business_units.data
                ? this.business_units.data
                : [];
              break;
            case "Designations":
              this.valueArray = this.designations
                ? this.designations[this.le_id]
                : [];
              break;
            default:
              this.valueArray = this.cost_centres
                ? this.cost_centres[this.le_id]
                : [];
              break;
          }
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to get customized data and hide the payroll cycle page */
    getThecustomPayCycleData(paycycleObj) {
      try {
        this.payrollCycleData = paycycleObj;
        this.payrollCycleData["selected_paygroup_id"] = null;
        this.showPayrollCycle = false;
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to get customized data and hide the pay computation page */
    getComputationData(paycomputeObj) {
      try {
        this.payComputationData = paycomputeObj;
        this.payComputationData["selected_paygroup_id"] = null;
        this.showPayComputation = false;
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },


/* function to hide payroll cycle page */
    hidePayrollCycle() {
      this.showPayrollCycle = false;
    },

    /* function to hide pay computation page */
    hidepaycomputation() {
      this.showPayComputation = false;
    },
    // PL_2480

    /* function to hide payslip page */
    hidepayslippreferences(val) {
      try {
        this.paySlipMapData = val;
        this.showPayslipPreferences = false;
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to customize the default settings of payroll cycle, pay computation and payslip */
    editPaygroupData(val) {
      try {
        // PL_3046
        if (val.name == "Payroll Cycle") {
          if (!Object.keys(this.payrollCycleData).length) {
            this.payrollCycleData = val.paygroupObj.PaygroupPayrollCycle && val.paygroupObj.PaygroupPayrollCycle[0]   // PL_3062
              ? val.paygroupObj.PaygroupPayrollCycle[0].PayrollCycle
              : {};
          }
          this.showPayrollCycle = true;
        }
        if (val.name == "Pay Computation") {
          if (!Object.keys(this.payComputationData).length) {
            this.payComputationData = val.paygroupObj.PaygroupPayComputation && val.paygroupObj.PaygroupPayComputation[0]    // PL_3062
              ? val.paygroupObj.PaygroupPayComputation[0].PayComputation
              : {};
          }
          this.showPayComputation = true;
        }
        if (val.name == "Payslip Preferences") {
          this.isCustom = true;
          this.showPayslipPreferences = true;
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to hide pop-up and navigate to pay group list page after getting succes from server */
    backfrompopup() {
      this.payrollCycleData = null;   // PL_3046
      this.payComputationData = null; // PL_3046
      this.paySlipMapData = null;    // PL_3046
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/paygroup`
      });
    },


    /* function to validate paygroup form */
    async savePaygroup() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    },

    /* function to set the payroll cycle data, pay computattion data, payslip data after selecting the dropdown copy setting from */
    paygroupSelectionChange(event, index) {
      try {
        if (event) {
          // PL_3027
          let payrollCycleObj = null;
          let payComputationObj = null;
          let payslipObj = null;
          if (event.name == "Custom") {
            let obj = this.payGroupListArray.find(item => item.default == true);
            payrollCycleObj = obj ? obj.PaygroupPayrollCycle[0] : null;    // PL_3062
            payComputationObj = obj ? obj.PaygroupPayComputation[0] : null;    // PL_3062
            payslipObj = obj ? obj.PayslipMapping[0] : null;   // PL_3062
          }
          switch (index) {
            case 0:
              this.payrollCycleData = event.PaygroupPayrollCycle && event.PaygroupPayrollCycle[0]   // PL_3062
                ? {
                    ...event.PaygroupPayrollCycle[0].PayrollCycle,
                    selected_paygroup_id: event.id
                  }
                : payrollCycleObj
                ? payrollCycleObj.PayrollCycle
                : {};
              break;
            case 1:
              this.payComputationData = event.PaygroupPayComputation && event.PaygroupPayComputation[0]    // PL_3062
                ? {
                    ...event.PaygroupPayComputation[0].PayComputation,
                    selected_paygroup_id: event.id
                  }
                : payComputationObj
                ? payComputationObj.PayComputation
                : {};
              break;
            case 2:
              this.paySlipMapData = event.PayslipMapping && event.PayslipMapping[0]     // PL_3062
                ? {
                    ...event.PayslipMapping[0].preferences,
                    selected_paygroup_id: event.id
                  }
                : payslipObj
                ? payslipObj.preferences
                : {};
              break;
            default:
              break;
          }
        } else {
          this.paygroupData[index].paygroupObj = this.paygroupObj; // PL_2870
        }
        this.$validator.reset();
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },


    /* server call to save the paygroup data */
    async performAction() {
      try {
        let criteriaAttribute = {
          criteria: this.paygroupFormData.criteriaObj,
          subCriteria: this.paygroupFormData.valueObj.map(item => {
            return item.id;
          }) // PL_2870
        };
        // Start PL_2870
        if (!this.paygroupFormData.default) {
          this.payrollCycleData.default = false;
          this.payComputationData.default = false;
          this.paySlipMapData.default = false;
        }
        // End PL_2870
        let obj = {
          data: {
            le_id: this.le_id,
            selectedPayrollPG: this.payrollCycleData,
            selectedPayComputationPG: this.payComputationData,
            selectedPreferencesPG: this.paySlipMapData,
            code: this.paygroupFormData.code,
            name: this.paygroupFormData.name.toString().trim(),
            default: this.paygroupFormData.default ? true : false,
            attribute: criteriaAttribute,
            description: this.paygroupFormData.description,
            applylop: this.paygroupFormData.applylop
          }
        };
        this.$root._data.isSaving = true;
        if (this.editMode) {
          obj.data.id = this.record.id;
          await this.act_update(obj);
        } else {
          delete obj.data.selectedPayComputationPG.id;
          delete obj.data.selectedPayrollPG.id;
          delete obj.data.selectedPreferencesPG.id;
          await this.act_create(obj);
        }
        setTimeout(() => {
          this.showSuccessMsg = true;
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* server call to get Grades for current Legal Entity */
    async getGrades() {
      try {
        await this.fetch_grades(this.le_id);
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* server call to get Salary bands for current Legal Entity */
    async getBands() {
      try {
        await this.fetch_bands(this.le_id);
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* server call to get Locations for current Legal Entity */
    async getLocationList() {
      try {
        await this.fetch_locations(this.le_id);
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* server call to get designations for current Legal Entity */
    async getDesignations() {
      try {
        await this.fetch_designation(this.le_id);
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to go back to paygroup table page */
    goBackToPaygroup() {
      this.refresh();
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/paygroup`
      });
    },

    /* function to refresh the page and form */
    refresh() {
      try {
        this.errmsg = "";
        this.toast = false;
        this.subCriteriaLabel = ""; // PL_2960
        this.valueArray = []; // PL_2960
        this.paygroupFormData.name = "";
        this.paygroupFormData.code = "";
        this.paySlipMapData = null;   // PL_3046
        this.payrollCycleData = null;   // PL_3046
        this.payComputationData = null;   // PL_3046
        this.paygroupFormData.description = "";
        this.paygroupFormData.default = false;
        this.$validator.reset();
        this.paygroupFormData.criteriaObj = null;
        this.paygroupFormData.valueObj = [];
        this.paygroupData = [
          {
            name: "Payroll Cycle",
            copySettings: "true",
            customize: true,
            paygroupObj: null
          },
          {
            name: "Pay Computation",
            copySettings: "true",
            customize: true,
            paygroupObj: null
          },
          {
            name: "Payslip Preferences",
            copySettings: "true",
            customize: true,
            paygroupObj: null
          }
        ];
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.business {
  width: 100%;
  height: 100%;
  margin-bottom: 200px;
  .top-bar {
    height: 64px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    padding: 24px 0 0 32px;
    img {
      cursor: pointer;
      margin-right: 24px;
    }
  }
}

.content-new {
  margin: 32px 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
}
.disabled {
  opacity: 0.3;
  pointer-events: none;
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

.custom-width-slotprop {
  width: 206px;
}
.alignClass {
  cursor: pointer;
}

.custom-grid {
  display: grid;
  grid-template-columns: 20% 20% 20%;
}
</style>
